/*
This file act as a between Old and NE engine code, so we can use the same WebApplication code for both engines
*/
export default class GLSceneBridge {
    constructor(glHandler, isOldEngine) {
        this.glHandler    = glHandler;
        this.isOldEngine = isOldEngine;
    }
    async loadProject(sceneJsonUrl) {
        if (this.isOldEngine) {
            const sceneName = await this.glHandler.loadScene(sceneJsonUrl);
            await this.glHandler.useScene( sceneName );
        }
        else {
            await this.glHandler.load();
        }
    }
    getProfile() {
        if (this.isOldEngine) {
            const OLD_TO_NEW_PROFILES = {
                0: 'Mobile',
                1: 'Desktop_Low',
                2: 'Desktop_Medium',
                3: 'Desktop_High',
            }
            const oldProfile = this.glHandler.getProfile();
            return OLD_TO_NEW_PROFILES[oldProfile];
        }
        else {
            return this.glHandler.getProfile();
        }
    }
    setProfile(profile) {
        if (this.isOldEngine) {
            const NEW_TO_OLD_PROFILES = {
                'Mobile':         0,
                'Desktop_Low':    1,
                'Desktop_Medium': 2,
                'Desktop_High':   3,
            }
            return this.glHandler.updateProfile(NEW_TO_OLD_PROFILES[profile]);
        }
        else {
            this.glHandler.setProfile(profile);
        }
    }
    incrementCameraRotationY(value) {
        if (this.isOldEngine) {
            this.glHandler.cameraRotationY += value;
        }
        else {
            this.glHandler?.incrementCameraRotationY?.(value);
        }
    }
    setIntroZoomProgress(value) {
        if (this.isOldEngine && value) {
            this.glHandler.introZoomProgress = value;
        }
    }
    getCameraProgress() {
        if (this.isOldEngine) {
            return this.glHandler.cameraProgress;
        }
    }
    setHomeDrag(value) {
        console.log('BRIDGE.setHomeDrag', value, {
            isOldEngine: this.isOldEngine,
            glHandlerm:  this.glHandler,
        });
        if (this.isOldEngine) {
            this.glHandler.homeCamera.drag = value;
        }
    }
    getUIPositions() {
        return this.glHandler?.getUIPositions?.() || {};
    }
    focusObject() {
        if (this.isOldEngine) {
            this.glHandler.focusObject(0);
        }
    }
    unfocusObject() {
        if (this.isOldEngine) {
            this.glHandler.unfocusObject();
        }
    }
    enterInnerRoom() {
        if (this.isOldEngine) {
            this.glHandler.enterInnerRoom();
        }
    }
    leaveInnerRoom() {
        if (this.isOldEngine) {
            this.glHandler.leaveInnerRoom();
        }
    }


    resize() {
        this.glHandler?.resize?.();
    }
    update() {
        this.glHandler?.update?.();
    }
    setCameraProgress(value) {
        if (this.isOldEngine) {
            this.glHandler.cameraProgress  = value;
        }
        else {
            this.glHandler?.setCameraProgress?.(value);
        }
    }
    resetCameraPathRotation() {
        this.glHandler?.resetCameraPathRotation?.();
    }

}